import React from "react";

import { ICellRendererParams } from "@ag-grid-community/core";

import Stage from "@mapmycustomers/shared/types/entity/deals/Stage";

import EntityTag from "@app/component/EntityTag";
import colors from "@app/styles/_colors.module.scss";
import anyColorToHex from "@app/util/colors/anyColorToHex";
import getContrastColor from "@app/util/colors/getContrastColor";

import styles from "./StageCellRenderer.module.scss";

const StageCellRenderer: React.FC<ICellRendererParams> = ({ value }) => (
  <div className={styles.container}>
    <EntityTag
      className={styles.tag}
      entity={value as Stage}
      textColor={
        getContrastColor((value as Stage).color) === "black"
          ? colors.slate
          : anyColorToHex((value as Stage).color)
      }
    />
  </div>
);

export default StageCellRenderer;
